import type { GetStaticPaths, GetStaticProps, NextPage } from 'next'

import { ArticlePage, ArticlePageProps } from 'src/App/ArticlePage/ArticlePage'
import {
  mapStrapiArticlesToClient,
  strapiGetArticles,
} from 'src/strapi/api/getArticles'
import { strapiClient } from 'src/strapi/client'
import {
  ArticleApiType,
  ArticleClientType,
} from 'src/strapi/types/articleTypes'
import { StrapiResponseWithPagination } from 'src/strapi/types/strapiTypes'

const Article: NextPage<ArticlePageProps> = (props) => (
  <ArticlePage key={props.article.slug} {...props} />
)

function pickRandomArticle(
  articles: Array<ArticleClientType>,
  alreadyChosenArticleSlug: string
) {
  const randomArticles = articles
    .sort(() => 0.5 - Math.random())
    .filter(({ slug }) => slug !== alreadyChosenArticleSlug)
    .slice(0, 3)

  return randomArticles
}

export const getStaticProps: GetStaticProps<ArticlePageProps> = async (ctx) => {
  const slug = ctx.params?.slug

  let article = {} as ArticleClientType
  const recommendedArticles: Array<ArticleClientType> = []

  try {
    const articleResp = await strapiClient.get<
      StrapiResponseWithPagination<ArticleApiType>
    >(`/articles?filters[slug][$eqi]=${slug}`)
    article = mapStrapiArticlesToClient(articleResp.data.data)[0]

    const articles = (await strapiGetArticles({
      withImage: true,
      withTags: true,
    })) as Array<ArticleClientType>

    recommendedArticles.push(...pickRandomArticle(articles, article.slug))

    if (!article) {
      throw new Error()
    }
  } catch (error) {
    console.log('Failed to create page blog/[slug]', error)
  }

  return {
    revalidate: false,
    props: {
      article,
      recommendedArticles,
    },
  }
}

export const getStaticPaths: GetStaticPaths = async () => {
  let articles: Array<ArticleClientType> = []

  try {
    const strapiArticles =
      (await strapiGetArticles()) as Array<ArticleClientType>

    if (!strapiArticles.length) {
      throw new Error()
    }

    articles = strapiArticles
  } catch (error) {
    throw new Error(
      'Failed to build paths for page /blog/[slug]',
      error as Error
    )
  }

  const paths = articles.map((article) => ({
    params: {
      slug: article.slug,
    },
  }))

  return {
    paths,
    fallback: false,
  }
}

export default Article
